import ListView from '@/components/common/ListView/ListView'
import ListViewColumn from '@/components/common/ListViewColumn/ListViewColumn'
import ListViewHeader, { ListViewHeaderColumn } from '@/components/common/ListViewHeader/ListViewHeader'
import ListViewRow from '@/components/common/ListViewRow/ListViewRow'
import { useTranslation } from 'next-i18next'
import React from 'react'

type Props = {}

const TyreSpeedIndex = (props: Props) => {
  const { t } = useTranslation()

  const columnSettings: ListViewHeaderColumn[] = [
    {
      name: 'speedIndex',
      label: t('tyres:speedIndex'),
      className: 'col-xs-2'
    },
    {
      name: 'speed',
      label: t('tyres:speedInKilometersPerHour'),
      className: 'col-xs'
    }
  ]

  const data = [
    {
      speedIndex: 'J',
      speed: '100'
    },
    {
      speedIndex: 'K',
      speed: '110'
    },
    {
      speedIndex: 'L',
      speed: '120'
    },
    {
      speedIndex: 'M',
      speed: '130'
    },
    {
      speedIndex: 'N',
      speed: '140'
    },
    {
      speedIndex: 'P',
      speed: '150'
    },
    {
      speedIndex: 'Q',
      speed: '160'
    },
    {
      speedIndex: 'R',
      speed: '170'
    },
    {
      speedIndex: 'S',
      speed: '180'
    },
    {
      speedIndex: 'T',
      speed: '190'
    },
    {
      speedIndex: 'U',
      speed: '200'
    },
    {
      speedIndex: 'H',
      speed: '210'
    },
    {
      speedIndex: 'V',
      speed: '240'
    },
    {
      speedIndex: 'ZR',
      speed: '>240'
    },
    {
      speedIndex: 'W',
      speed: '270'
    },
    {
      speedIndex: 'Y',
      speed: '300'
    }
  ]   

  return (
    <div>
      <ListView
        columns={columnSettings}
      >
        {
          (columns) => {
            return (
              <>
                <ListViewHeader columns={columnSettings} />                
                {data.map((item, index) => (
                  <ListViewRow key={index}>
                    <ListViewColumn column={columns.speedIndex} >
                      {item.speedIndex}
                    </ListViewColumn>
                    <ListViewColumn column={columns.speed}>
                      {item.speed}
                    </ListViewColumn>
                  </ListViewRow>
                ))}

              </>
            )
          }
        }
      </ListView>
    </div>
  )
}

export default TyreSpeedIndex